import {Component, Vue, Watch} from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { UserModule } from '@/store/modules/user'
import {getDeparmentList, gettHeaderByType, settHeaderByType} from '@/api/common'
import { delNullProperty } from '@/utils/index'
import {
    getFinanceOrderList,
    financeOrderExportData,
    setFinanceOrderStatus,
    delFinanceOrderById,
    financeOrderBowOutById,
    setFinanceOrderCaseStatusById,
    setFinanceOrderCaseStatusByIdList, getStudentOutputById
} from '@/api/financial-center'
import { formatDate } from '@/utils/timeFilter'
import { Loading } from 'element-ui';
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

const projectTypeFilter = commonData.projectTypeZeroArray
@Component({
    components:{
        MoreUsersFilter
    }
})
export default class Order extends Vue {
    projectTypeFilter = projectTypeFilter //项目类型
    page = 1
    total = 0
    limit = 20
    tableHeadPopoverShow = false

    tableHeader: { filds: string; cnFilds: string; isShow: boolean; id: number }[] = []
    tableData = []
    // tableRandom = Math.random()
    tableLoading = false
    filter_souCourseType = []
    filter_souCourseSchoolBegin: Date[] = []
    finishAt: Date[] = [] //服务完成时间
    companyName = '' //所属公司
    filter_costomerName = ''
    filter_adviser = ''
    filter_userIdList: string[] = []
    filter_costomerType = ''
    filter_caseStatus = ''
    filter_types = ''
    filter_isDissertation = '' //订单类别
    filter_status = ''
    filter_haveIPQ = ''
    filter_createdAt: Date[] = []
    filter_code = '' //订单编号
    filter_customerSource  = '' //客户来源
    filter_price  = '' //订单金额
    filter_amount = '' //订单金额
    filter_commissionType  = '' //佣金类型
    filter_source  = '' //来源 选项1：普通来源 选项2： 合作伙伴
    filter_financeBackMoneyStatus = [] // 回款状态
    commissionTypeList = [
        { key: '无佣金类型', value: '0' },
        { key: '结算价', value: '1' },
        { key: '返点', value: '2' },
    ]
    filter_priceOrRatio  = '' //返点比例
    filter_ratio   = '' //返点比例
    filter_discountPrice  = '' //优惠金额
    filter_discount  = '' //优惠金额

    filter_souCourseName  = '' //项目名称
    filter_isWL  = '' //wl是否发送
    filter_courseCode= '' // courseCode
    cancelApproveDialog = false
    cancelApproveId: number = undefined
    applyChargebackDialog = false   //申请退项
    applyChargeback = ''
    cancelDelDialog = false //删除订单
    delId: number

    selectBackMoneyDialog = false
    newBackMoneyType = ''
    newBackMoneOrderId = ''

    delOrderId: number = null
    delOrderDialogShow = false

    transferCaseDialog = false  //转案
    orderOutId: number = undefined // 退项订单id
    exportButtonDisabled = false
    exportHeaderDialogVisible = false

    // checkTableList: any[] = [] // 选中的表格数据 --- 详细数据
    innerWidth = 0
    showButton = false
    orderOutIdList: any[] = []
    disBtn = false
    applyBackCakeBtn = false
    vdaH = 0 //屏幕高度
    originHeight: any = '' //屏幕高度
    heightScroll = false
    tableKey = Math.random()
    timer = null
    popHeight = 0
    draggableList = []
    draggableListChange = []
    transferCaseBatchDialog = false // 批量转案
    filter_cooperSource = '' // 合作伙伴来源
    departmentIdList= []
    deparmentList: any = [] // 部门列表
    checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
    accessibleList: any = []
    checkDeparmentInfo: any = [] // 选中的部门信息
    backMoneyType = ''
    dialogVisible = false
    fileList: any = []
    contractNo = ''
    isCredit = ''
    applyChargebackLoading = false
    transferCaseLoading = false
    souTeacherName = ''
    activeIndex = 0

    get createdAt() {
        let str = ''
        if(!this.filter_createdAt || this.filter_createdAt.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.filter_createdAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.filter_createdAt[1]))
        }
        return str
    }
    get timeBegin() {
        let str = ''
        if(!this.filter_souCourseSchoolBegin || this.filter_souCourseSchoolBegin.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.filter_souCourseSchoolBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.filter_souCourseSchoolBegin[1]))
        }
        return str
    }
    get finishTimeBegin() {
        let str = ''
        if(!this.finishAt || this.finishAt.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.finishAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.finishAt[1]))
        }
        return str
    }

    get arrfilter_price() {
        const filter_price = this.filter_price
        const filter_amount = this.filter_amount
        return {
            filter_price, filter_amount
        }
    }

    get arrfilter_ratio() {
        const filter_ratio = this.filter_ratio
        const filter_priceOrRatio = this.filter_priceOrRatio
        return {
            filter_ratio, filter_priceOrRatio
        }
    }

    get arrfilter_discount() {
        const filter_discount = this.filter_discount
        const filter_discountPrice = this.filter_discountPrice
        return {
            filter_discount, filter_discountPrice
        }
    }



    menuBtn = menuBtn

    created() {
        this.gettHeaderByType()
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260 ;
        this.popHeight = this.vdaH
        this.getDeparment()
    }
    updated(){
        // this.$nextTick(() => {
        //     let h = document.documentElement.clientHeight || document.body.clientHeight;
        //     this.vdaH = h - 140 + 'px' + '!important';
        //     this.originHeight = document.getElementById("idu").offsetHeight;
        //     if(this.originHeight > h){ //盒子超出屏幕高度
        //         this.heightScroll = true
        //     }else {
        //         this.heightScroll = false
        //     }
        // })
    }

    async getDeparment() {
        const data: any = await getDeparmentList()
        this.deparmentList = data
    }


    chooseDepartment(checkedKeys){
        // console.log('checkedKeys',checkedKeys)

        const tree = this.$refs.tree as HTMLFormElement
        const arr = []
        tree.forEach(item => {
            arr.push(item.getCheckedKeys())
        })

        // console.log('arr',arr)
        function flatter(arr) {
            //此代码的意思是接受一个数组作为参数
            const newArr = [];  // 这个空数组用于处理扁平化之后的数组元素
            function fn(date) {  //如果date是一个数组就需要对date经行遍历
                for (let i = 0; i < date.length; i++) {
                    const tem = date[i];  // 使用tem储存每一个数组的元素
                    if (Array.isArray(tem)) { //表示如果tem是一个数组，则执行下面的函数
                        fn(tem)  //调用fn函数，并传入一个实参
                    } else {
                        newArr.push(tem);//此代码的意思是，如果不是一个数组就把每个元素push到newArr 这个数组中
                    }
                }
            }

            fn(arr) //表示调用上面的fn函数，并且传入一个实参arr
            return newArr //表示返回这个结果，讲这个结果返回给这个函数的调用者
        }

        const p = flatter(arr) //表示返回这个结果，并且赋值给p

        this.departmentIdList = p
    }

    treeChange(item: any, itembol: boolean) {

    }


    async gettHeaderByType() {
        const data: any = await gettHeaderByType(8)
        this.draggableList = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = data.headerUserList
        this.tableHeader = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }
    async getTableData() {
        if(this.filter_price && ! /^[0-9]+$/.test(this.filter_price)) {
            this.$message.error('订单金额只能输入正整数！')
            return
        }
        const price = this.filter_amount + this.filter_price
        const priceOrRatio = this.filter_ratio + this.filter_priceOrRatio
        const discountPrice = this.filter_discount + this.filter_discountPrice
        this.tableLoading = true

        const obj = {
            customerName: this.filter_costomerName,
            customerType: this.filter_costomerType,
            caseStatus: this.filter_caseStatus,
            types: this.filter_types,
            isDissertation:this.filter_isDissertation,
            status: this.filter_status,
            haveIPQ: this.filter_haveIPQ,
            createdAt: this.createdAt,
            directorUserIdList: this.filter_userIdList,
            limit: this.limit,
            page: this.page,
            souCourseTypeIdList:this.filter_souCourseType,
            souCourseSchoolBegin: this.timeBegin,
            adviser: this.filter_adviser,
            code: this.filter_code, //订单编号
            customerSource: this.filter_customerSource, //客户来源
            price: price, //订单金额
            commissionType: this.filter_commissionType, //佣金类型
            priceOrRatio: priceOrRatio, //返点比例
            discountPrice: discountPrice, //优惠金额
            souCourseName: this.filter_souCourseName, //项目名称
            courseCode: this.filter_courseCode, //项目名称
            isWL: this.filter_isWL, //wl是否发送
            finishAt: this.finishTimeBegin, //服务完成时间
            companyName: this.companyName, //所属公司
            sourceType: this.filter_source, //来源
            backMoneyStatusList: this.filter_financeBackMoneyStatus, //回款状态
            marketCooperationSource: this.filter_cooperSource, // 合作伙伴来源
            departmentIdList:this.departmentIdList,
            marketCooperationBackMoneyType:this.backMoneyType,
            contractNo:this.contractNo,
            isCredit:this.isCredit,
            souTeacherName:this.souTeacherName,
        }

        if(this.filter_amount && !this.filter_price){
            delete obj.price
        }
        if(this.filter_discount && !this.filter_discountPrice){
            delete obj.discountPrice
        }
        if(this.filter_ratio && !this.filter_priceOrRatio){
            delete obj.priceOrRatio
        }

        for(const key in obj) {
            if(obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        try {
            const data: any = await getFinanceOrderList(delNullProperty(obj))
            this.tableData = data.financeOrderList
            this.total = data.allNum
            this.tableLoading = false
    
            this.tableKey = Math.random()
            this.$nextTick(() => {
                if (this.$refs.multipleTable) {
                    (this.$refs.multipleTable as HTMLFormElement).doLayout();
                    (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
                }
            });
        } catch (error) {
            this.tableLoading = false
        }
    }

    // 申请退项
    clickApplyChargeback(row) {
        this.orderOutId = row.id
        this.applyChargebackDialog = true
    }

    async clickChargebackConfirmButton() {
        if (!this.applyChargeback) {
            this.$message.error('请填写退项原因');
            return
        }
        this.applyChargebackLoading = true
        this.applyBackCakeBtn = true
        await financeOrderBowOutById({id: this.orderOutId, reason: this.applyChargeback}).then(() => {
            this.$message.success('申请退项成功')
            this.applyChargebackDialog = false
            this.applyBackCakeBtn = false
            this.applyChargebackLoading = false
        }).catch(() => {
            this.applyChargebackDialog = false
            this.applyBackCakeBtn = false
            this.applyChargebackLoading = false
        })

        this.applyChargeback = ''
        this.getTableData()
    }

    // 转案
    clickTransferCase(row) {
        this.orderOutId = row.id
        this.transferCaseDialog = true
    }

    async clickTransferCaseDialogConfirmButton() {
        this.disBtn = true
        this.transferCaseLoading = true
        try {
            await setFinanceOrderCaseStatusById({id: this.orderOutId})
            this.$message.success('发起转案成功')
            this.getTableData()
            this.orderOutId = null
            this.transferCaseDialog = false
            this.disBtn = false
            this.transferCaseLoading = false
        } catch {
            this.orderOutId = null
            this.transferCaseDialog = false
            this.disBtn = false
            this.transferCaseLoading = false
        }
    }


    // 查看
    clickViewButton(row){
        if (!this.menuBtn(55)) return
        if (row.isDissertation == '论文订单') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/paperOrderInfo?id=' + row.id + '&status=' + row.status + '&isUpdatedData=0' + '&isShow=' + row.isShow)
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
        }
        if (row.isDissertation == '普通订单') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/orderInfo?id=' + row.id + '&status=' + row.status + '&orderType=' + row.types + '&isUpdatedData=0' + '&isShow=' + row.isShow)
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
        }
    }

    openRecordPage() {
        window.open(window.location.origin + this.$route.matched[0].path + '/orderRecord')
    }
    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }
    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({
                headerIds: this.draggableList,
                types: 8
            })
            this.tableHeadPopoverShow = false
            this.$message.success('修改表头成功')
            this.gettHeaderByType()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel() {
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false
    }

    async exportExcel(keys: string = '') {
        const price = this.filter_amount + this.filter_price
        const priceOrRatio = this.filter_ratio + this.filter_priceOrRatio
        const discountPrice = this.filter_discount + this.filter_discountPrice
        this.exportButtonDisabled = true
        const obj = {
            customerName: this.filter_costomerName,
            customerType: this.filter_costomerType,
            caseStatus: this.filter_caseStatus,
            types: this.filter_types,
            isDissertation:this.filter_isDissertation,
            status: this.filter_status,
            haveIPQ: this.filter_haveIPQ,
            createdAt: this.createdAt,
            directorUserIdList: this.filter_userIdList,
            customerSource: this.filter_customerSource,
            finishAt: this.finishTimeBegin, //服务完成时间
            companyName: this.companyName, //所属公司
            souCourseTypeIdList:  this.filter_souCourseType,
            souCourseSchoolBegin: this.timeBegin,
            adviser: this.filter_adviser,
            code: this.filter_code, //订单编号
            price: price, //订单金额
            commissionType: this.filter_commissionType, //佣金类型
            priceOrRatio: priceOrRatio, //返点比例
            discountPrice: discountPrice, //优惠金额
            souCourseName: this.filter_souCourseName,
            courseCode: this.filter_courseCode,
            isWL: this.filter_isWL, //wl是否发送
            sourceType: this.filter_source, //来源
            backMoneyStatusList: this.filter_financeBackMoneyStatus, //回款状态
            marketCooperationSource: this.filter_cooperSource, //合作伙伴来源
            departmentIdList: this.departmentIdList, //负责人所属部门
            marketCooperationBackMoneyType:this.backMoneyType,
            contractNo:this.contractNo,
            isCredit:this.isCredit,
            souTeacherName:this.souTeacherName,
            keys,
        }
        for (const key in obj) {
            if (obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        financeOrderExportData(delNullProperty(obj))
            .then(()=>{
                this.$message.success('数据已转入后台导出, 请前往下载列表查看')
            })
            .finally(() => {
            this.exportButtonDisabled = false
        })
    }

    clickcancelApproveButton(row) {
        this.cancelApproveId = row.id
        this.cancelApproveDialog = true
    }

    async clickCancelApproveDialogConfirmButton() {
        await setFinanceOrderStatus({id: this.cancelApproveId, action: '1'})
        this.$message.success('撤销审批成功')
        this.cancelApproveDialog = false
        this.getTableData()
    }

    clickSubmitApproveButton(row) {
        if (row.isDissertation == '论文订单') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/newPaperOrder?orderId=' + row.id + '&status=' + row.status + '&isUpdatedData=1')
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
        }
        if (row.isDissertation == '普通订单') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/newOrdinaryOrder?orderId=' + row.id + '&status=' + row.status + '&orderType=' + row.types + '&isUpdatedData=1')
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
        }
    }

    openNewOrderPage() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/newOrdinaryOrder')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    openNewPaperPage() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/newPaperOrder')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }

    clickNewBackMoneyButton(row) {
        this.newBackMoneOrderId = row.id
        if (row.sourceType === '合作伙伴') {  // 1- 合作伙伴
            this.selectBackMoneyDialog = true
        }
        if (row.sourceType === '普通来源') { // 0- 普通来源
            this.newBackMoneyType = '1'
            this.selectBackMoneyMainDialogConfirm()
        }
    }

    clickDelOrderButton(id) {
        this.delOrderId = id
        this.delOrderDialogShow = true
    }

    async delOrderDialogConfirm() {
        await delFinanceOrderById(this.delOrderId)
        this.$message.success('删除成功')
        this.delOrderDialogShow = false
        this.getTableData()
    }

    selectBackMoneyMainDialogConfirm() {
        let url = ''
        if (this.newBackMoneyType === '1') {
            url = this.$route.matched[0].path + '/newBackMoneyStudent?orderId=' + this.newBackMoneOrderId
        }
        if (this.newBackMoneyType === '2') {
            url = this.$route.matched[0].path + '/newBackMoneyMechanism?orderId=' + this.newBackMoneOrderId
        }
        const win = window.open(url, '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
        this.selectBackMoneyDialog = false
    }

    // 跳转统计图表页面
    goToDtatisticsData() {
        const {origin} = window.location
        const src = origin + '/financialCenter/statisticsData'
        window.open(src, '_blank')
    }

    // orderTableSelect(row) {
    //     return row.caseStatus !== "已转案"
    // }

    // 数组去重
    newArrFn(arr) {
        const newArr: any = []
        for (let i = 0; i < arr.length; i++) {
            newArr.indexOf(arr[i]) === -1 ? newArr.push(arr[i]) : newArr
        }
        return newArr
    }

    // 批量转案
    async handleBatch() {
        const newArr = this.newArrFn(this.orderOutIdList)
        if (newArr && newArr.length > 0) {
            // 加loading
            const loadingInstance = Loading.service({fullscreen: true});
            try {
                const res: any = await setFinanceOrderCaseStatusByIdList({
                    idList: newArr
                })
                const failNum = res.failNum
                const successNum = res.successNum
                this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    loadingInstance.close();
                });
                // successNum: 5
                this.$message.success(successNum + '条发起转案成功' + '，' + failNum + '条发起转案失败')
                this.getTableData()
                this.orderOutIdList = []
                // this.transferCaseDialog = false
                this.transferCaseBatchDialog = false
            } catch {
                this.orderOutIdList = []
                // this.transferCaseDialog = false
                this.transferCaseBatchDialog = false
            }
        } else {
            this.$message.error('请选择符合转案规则的数据！')
        }
    }

    // 表格选中情况发生改变时
    handleSelectionChange(arr: any) {
        this.orderOutIdList = []

        // this.checkTableList = arr
        // this.innerWidth = window.innerWidth
        arr.forEach(item => {
            //筛选符合条件的
            if (!this.menuBtn(60)) return
            if (item.isDissertation == '普通订单' && (item.caseStatus == '待转案' || item.caseStatus == '被驳回') && item.isShow === '1') {
                this.orderOutIdList.push(item.id)
            }
        })

        // 移动端适配
        // if(this.innerWidth < 751 && this.checkTableList.length > 0) {
        //     this.showButton = true
        // }
    }


    clickEditButton(row) {
        if (row.isDissertation == '论文订单') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/newPaperOrder?orderId=' + row.id + '&status=' + row.status + '&isUpdatedData=1')
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
        }
        if (row.isDissertation == '普通订单') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/newOrdinaryOrder?orderId=' + row.id + '&status=' + row.status + '&orderType=' + row.types + '&isUpdatedData=1')
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
        }
    }

    changeUseridList(e){
        this.filter_userIdList = e.id
        this.page = 1
        this.getTableData()
    }

    doCanceltranferCase(){
        this.orderOutIdList = []
        this.transferCaseBatchDialog = false
    }

    downloadOutput(id) {
        getStudentOutputById({id: id}).then((res: any) => {
            this.fileList = res.studentOutputList
            this.dialogVisible = true
        })
    }

    doDownload(path, name) {
        /*   根据线上存储地址下载图片*/
        const xhr = new XMLHttpRequest()
        xhr.open('GET','https://gecacademy.oss-cn-beijing.aliyuncs.com/crm/'+ path, true)
        xhr.responseType = 'blob'
        xhr.onload = function () {
            if (this.status === 200) {
                const blob = this.response
                const a = document.createElement('a')
                a.href = window.URL.createObjectURL(blob)
                a.download = name
                a.click()
                URL.revokeObjectURL(a.href)
            }
        }
        xhr.send()
    }

    doDownloadCancel() {
        this.dialogVisible = false
    }

    /*应收账款统计报表*/
    openARSummaryReport (){
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ARSummaryReport')
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }
  
    @Watch('arrfilter_price')
    handlearrfilter_price(nVal, oVal) {
        if ((nVal.filter_price && nVal.filter_amount)|| (!nVal.filter_price && !nVal.filter_amount)) {
            this.pageChange(1)
        }
    }

    @Watch('arrfilter_ratio')
    handlearrfilter_ratio(nVal, oVal) {
        if ((nVal.filter_ratio && nVal.filter_priceOrRatio)||(!nVal.filter_ratio && !nVal.filter_priceOrRatio)) {
            this.pageChange(1)
        }
    }

    @Watch('arrfilter_discount')
    handlearrfilter_discount(nVal, oVal) {
        if ((nVal.filter_discount && nVal.filter_discountPrice)||(!nVal.filter_discount && !nVal.filter_discountPrice)) {
            this.pageChange(1)
        }
    }




}
